cv.SetupTeamsRowView = Marionette.LayoutView.extend({
  tagName: 'div',
  className: 'result',
  template: cv.Templates['setup/teams/setup_teams_row'],

  events : {
    'click .result-body' : 'chooseRecipient',
    'click .result-remove' : 'removeRecipient'
  },

  templateHelpers: function(){
    return {
      name : this.model.get('name'),
      photo_path : cv.photo({
        photo_path : this.model.get('photo_path'),
        transforms : {
          fit : 'crop'
        },
        url_only : true
      })
    };
  },

  initialize: function(options){
    console.log('SetupTeamsRowView initialized');
  },

  removeRecipient: function(e){
    e.preventDefault();

    if(!this.$el.hasClass('active')){
      return false;
    }

    this.$el.removeClass('active');


    $.ajax({
			url: "/b/teams/" + this.model.get('id') + "/members",
			dataType: "json",
      data : {
        project_id : cv.project.get('id'),
        delete : 'DELETE'
      },
			type: 'post',
			success: _.bind(function(data){
				cv.PRELOADED.project_teams = _.without(cv.PRELOADED.project_teams, _.findWhere(cv.PRELOADED.project_teams, { id: this.model.get('id') }));
        console.log(cv.PRELOADED.project_teams);
			}, this)
		});
  },

  chooseRecipient: function(e){
    e.preventDefault();

    if(this.$el.hasClass('active')){
      return false;
    }
    this.$el.addClass('active');

    $.ajax({
			url: "/b/teams/" + this.model.get('id') + "/members",
			dataType: "json",
      data : {
        project_id : cv.project.get('id')
      },
			type: 'post',
			success: _.bind(function(data){
				cv.PRELOADED.project_teams.push({ id : this.model.get('id') });
        console.log(cv.PRELOADED.project_teams);
			}, this)
		});
  },

  onShow: function(){
    imgix.fluid(this.$el.get(0), {
      updateOnResizeDown: true,
      pixelStep: 5,
      autoInsertCSSBestPractices: true
    });

    var tmp = _.findWhere(cv.PRELOADED.project_teams, { id : this.model.get('id') });
    if(!_.isUndefined(tmp)){
      this.$el.addClass('active');
    }
  }
});
